import { createApi } from '@reduxjs/toolkit/query/react'
import customFetchBase from '../services/CustomFetchBase'

/**
 * API slice for handling payment-related operations.
 */
export const paymentApi = createApi({
    reducerPath: 'paymentApi',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        /**
         * Mutation to validate a payment link.
         * @param {Object} userData - The request body containing payment link details.
         * @returns {Promise<any>} The response from the server indicating whether the payment link is valid.
         */
        validatePaymentLinkApi: builder.mutation({
            query: (userData) => ({
                url: '/validate-payment-link',
                method: 'POST',
                body: userData
            }),
            onQueryStarted: async (args, { queryFulfilled }) => {
                try {
                    await queryFulfilled
                } catch (error) {}
            }
        }),

        /**
         * Mutation to process a payment.
         * @param {Object} userData - The request body containing payment details.
         * @returns {Promise<any>} The response from the server confirming the payment processing status.
         */
        processPaymentApi: builder.mutation({
            query: (userData) => ({
                url: '/process-payment',
                method: 'POST',
                body: userData
            }),
            onQueryStarted: async (args, { queryFulfilled }) => {
                try {
                    await queryFulfilled
                } catch (error) {}
            }
        })
    })
})

/**
 * Auto-generated hooks for the defined mutations.
 */
export const { useValidatePaymentLinkApiMutation, useProcessPaymentApiMutation } = paymentApi
